<form nz-form class="address-form mr-2" autocomplete="off">
	<div class="title-30 color-blue">
		{{ "global.org_settings.sub_organisation.title" | translate }}
	</div>
	<div class="subtitle-30 color-grey">
		{{ "global.org_settings.sub_organisation.subtitle" | translate }}
	</div>
	<div class="mt-2">
		<nz-input-group [nzAddOnAfter]="suffixIconButton" nzSize="large" class="table-searchbox">
			<input placeholder="input here" nz-input (change)="onChange($event.target.value)"/>
			<ng-template nzSize="medium" #suffixIconButton>
				<button nz-button class="transparent" nzSearch>
					<i nz-icon nzType="search" nzTheme="outline"></i>
				</button>
			</ng-template>
		</nz-input-group>
		<div class="table-modification float-right mb-1">
			<button nz-button (click)="displayCreateSubOrganisationModal()"
				class="add-button border-radius-5 color-blue border-color-blue" [nzType]="'Primary'">
				<i nz-icon nzType="plus" nzTheme="outline"></i>Add
			</button>
		</div>
	</div>
	<nz-table class="mt-2" #rowSelectionTable nzShowSizeChanger [nzData]="listOfData" [nzShowPagination]="false">
		<thead>
			<tr>
				<th *ngFor="let column of listOfColumn" [nzSortOrder]="column.sortOrder" [nzSortFn]="column.sortFn"
					[nzSortDirections]="column.sortDirections" [nzWidth]="column?.width">
					{{ column.title }}
				</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let data of rowSelectionTable.data">
				<td>{{ data.role }}</td>
				<td>{{ data.admin }}</td>
			</tr>
		</tbody>
	</nz-table>
</form>
<nz-modal [(nzVisible)]="createSubOrganisationModalVisible" (nzOnCancel)="handleCancel(createSubOrganisationForm)"
	(nzOnOk)="handleOk(createSubOrganisationForm)" [nzTitle]="modalTitle" nzCentered
	[nzStyle]="createSubOrganisationModalStyle">
	<ng-template #modalTitle class="font-800">
		Create new Sub-Organisation from <span class="color-blue">&lt;Organisation Name&gt;</span>
	</ng-template>
	<ng-container *nzModalContent>
		<div class="center">
			<form [formGroup]="createSubOrganisationForm" class="half-width">
				<nz-form-item class="input-field title-14">
					<nz-form-control>
						<app-input-field [size]="'large'" [form]="createSubOrganisationForm"
							[label]="'Organisation Name'" placeholder="Organisation Name"
							[formName]="'organisationName'">
						</app-input-field>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item>
					<nz-form-control>
						<div class="input-field-label">Select Owner of new Sub-Organization</div>
						<nz-select [nzDropdownClassName]="'custom-user-select-dropdown'" class="custom-user-selector" [nzSize]="'large'" [nzMaxMultipleCount]="1"
							formControlName="person" nzMode="multiple" nzPlaceHolder="Enter Name of new owner or Me">
							<nz-option class="custom-select-item" *ngFor="let option of users" nzLabel="@{{option.name}} ({{option.email}})"
								[nzValue]="option.name">
								{{option.name}} ({{ option.email }})</nz-option>
						</nz-select>
					</nz-form-control>
				</nz-form-item>
			</form>
		</div>
	</ng-container>
	<div *nzModalFooter>
		<button nz-button nzType="default" class="color-grey border-none"
			(click)="handleCancel(createSubOrganisationForm)">Back</button>
		<button nzType="primary" nz-button [disabled]="createSubOrganisationForm.invalid" class="border-radius-5"
			(click)="handleOk(createSubOrganisationForm)">Create</button>
	</div>
</nz-modal>
